export default __webpack_public_path__ + "static/18-94a7827f5d8524d24d32bc9c540f5c6a.png";